import React from 'react';
import { useFlow, createFeature } from '@edreamsodigeo/frontend-core';
import { RevampContext } from 'context';
import { CHECKED_BAGS_ONE_CLICK } from '../../../versionedComponents';

const RevampProvider = ({ isRevamp, children }) => {
  return (
    <RevampContext.Provider value={{ isRevamp: isRevamp }}>
      {children}
    </RevampContext.Provider>
  );
};

const VersionedDesktopRevampProvider = createFeature({
  name: CHECKED_BAGS_ONE_CLICK,
  variations: [
    (props) => <RevampProvider isRevamp={false} {...props} />,
    (props) => <RevampProvider isRevamp={false} {...props} />,
    (props) => <RevampProvider isRevamp={true} {...props} />,
  ],
  version: 1,
});

const VersionedMobileRevampProvider = createFeature({
  name: 'ALT_ALT3815_M',
  variations: [
    (props) => <RevampProvider isRevamp={false} {...props} />,
    (props) => <RevampProvider isRevamp={true} {...props} />,
  ],
  version: 1,
});

export const VersionedRevampProvider = ({ children }) => {
  const deviceFlow = useFlow();
  return deviceFlow === 'mobile' ? (
    <VersionedMobileRevampProvider>{children}</VersionedMobileRevampProvider>
  ) : (
    <VersionedDesktopRevampProvider>{children}</VersionedDesktopRevampProvider>
  );
};
